import React, { useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { actions as sharedStateActions } from 'containers/SharedState/slice';
import { useDataDashboardContext } from 'containers/Visibility/Data/Components/hooks/context';
import { VISIBILITY_DATA_TAB_STORAGE_KEY } from 'containers/Visibility/Data/Components/utils';
import { selectDataDashboard } from 'containers/Visibility/Data/selectors';
import { useSearchParams } from 'hooks/useSearchParams';

import { DataTable } from './DataTable';

export const DataTables: React.FC = () => {
  const { getTableData } = useDataDashboardContext();
  const { selectedTab } = useSelector(selectDataDashboard);
  const params = useSearchParams<{ tab?: string }>();
  const dispatch = useDispatch();
  const storedVisibilityDataTab = localStorage.getItem(
    VISIBILITY_DATA_TAB_STORAGE_KEY,
  );
  const requestedTab = params.tab || storedVisibilityDataTab || 'DataSources';

  useEffect(() => {
    // Avoid the default-tab request racing the URL-selected tab on first mount.
    if (selectedTab !== requestedTab) return;
    getTableData();
  }, [getTableData, requestedTab, selectedTab]);

  useEffect(() => {
    dispatch(sharedStateActions.getRegions({ q: {} }));
  }, [dispatch]);

  return (
    <Box flex={1} w="full" h="full">
      <ActiveResourceProvider>
        <DataTable />
      </ActiveResourceProvider>
    </Box>
  );
};
